export default {
  guests_pay: 'Les clients payent {{amount}} lors du paiement (dernier taux de change).',
  missing_rate:
    "Pas de taux de change pour {{currency}} pour l'instant, les clients payent donc {{amount}} sans conversion.",
};
